// components/AIQuestionPromptModal.jsx
import { useState } from "react";
import { Modal } from "react-bootstrap";
import { Icon } from "@iconify/react";

export default function AIQuestionPromptModal({ show, onClose, onGenerate }) {
  const [topic, setTopic] = useState("");
  const [loading, setLoading] = useState(false);

  const handleGenerate = async () => {
    if (!topic.trim()) return;
    setLoading(true);
    try {
      await onGenerate(topic);
    } catch (err) {
      console.error("AI generation failed:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      show={show}
      onHide={loading ? undefined : onClose} // disable close if loading
      centered
      size="md"
      backdrop={loading ? "static" : true} // block outside click when loading
      keyboard={!loading} // block ESC key when loading
    >
      <Modal.Header
        closeButton={!loading} // hide close button while generating
        className="border-0 pb-0"
      >
        <Modal.Title className="fw-bold fs-0 d-flex align-items-center gap-2 pb-0">
          <Icon
            icon="ic:baseline-auto-awesome"
            className="text-primary"
            style={{ fontSize: "1.25rem" }} // smaller sparkle
          />
          <span style={{ fontSize: "24px" }}>Generate AI Questions</span>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="pt-4">
        <p className="text-muted small mb-3">
          Enter a topic and let AI create multiple questions & answers for you.
        </p>
        <div className="mb-3">
          <label className="form-label fw-semibold">Topic</label>
          <input
            type="text"
            className="form-control form-control-lg shadow-sm"
            placeholder="e.g., Fun Icebreaker Questions"
            value={topic}
            onChange={(e) => setTopic(e.target.value)}
            disabled={loading}
            onInput={(e) => {
              e.target.value = e.target.value
                .replace(/\s{2,}/g, " ") 
                .trimStart(); 
            }}
          />
        </div>
      </Modal.Body>

      <Modal.Footer className="border-0 pt-0">
        <button
          className="btn btn-light px-4"
          onClick={onClose}
          disabled={loading}
        >
          Cancel
        </button>
        <button
          className="btn btn-primary px-4"
          onClick={handleGenerate}
          disabled={!topic.trim() || loading}
        >
          {loading ? (
            <>
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
              ></span>
              Generating...
            </>
          ) : (
            <>Generate</>
          )}
        </button>
      </Modal.Footer>
    </Modal>
  );
}
